import styled from "styled-components";
import IconButton from "@mui/material/Icon";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px;
`;

export const IconeButton = styled(IconButton)`
    position: 'absolute';
    right: 10px;
    top: 10px;
    color: #111;
`;

export const Loader = styled.div`
    display: flex;
    height: 40px;
    justify-content: center;
`;
